import React, { useEffect, useState } from 'react';
import { NavLink, Link, Outlet } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from './config';
import './Pipeline.css';

function PipelineLayout() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/pipeline/stats`)
      .then(res => setStats(res.data))
      .catch(() => {});
  }, []);

  return (
    <div className="app-layout pr-wrapper">
      <nav className="sidebar">
        <div className="sidebar-header">
          <Link to="/pipeline" className="sidebar-logo">
            <span className="logo-icon">PR</span>
            <span className="logo-text">Inflammation Pipeline Radar</span>
          </Link>
        </div>

        {stats && (
          <div className="sidebar-stats">
            <div className="stat-item">
              <span className="stat-value">{stats.total_programs ?? '—'}</span>
              <span className="stat-label">Programs</span>
            </div>
            <div className="stat-item">
              <span className="stat-value">{stats.total_companies ?? '—'}</span>
              <span className="stat-label">Companies</span>
            </div>
            <div className="stat-item">
              <span className="stat-value">{stats.total_trials ?? '—'}</span>
              <span className="stat-label">Trials</span>
            </div>
          </div>
        )}

        <ul className="sidebar-nav">
          <li>
            <NavLink to="/pipeline" end className={({ isActive }) => isActive ? 'pr-nav-link active' : 'pr-nav-link'}>
              Pipeline
            </NavLink>
          </li>
          <li>
            <NavLink to="/pipeline/companies" className={({ isActive }) => isActive ? 'pr-nav-link active' : 'pr-nav-link'}>
              Companies
            </NavLink>
          </li>
          <li>
            <NavLink to="/pipeline/indications" className={({ isActive }) => isActive ? 'pr-nav-link active' : 'pr-nav-link'}>
              Indications
            </NavLink>
          </li>
          <li>
            <NavLink to="/pipeline/changes" className={({ isActive }) => isActive ? 'pr-nav-link active' : 'pr-nav-link'}>
              Changes
            </NavLink>
          </li>
        </ul>

        <div className="sidebar-footer">
          <span className="sidebar-version">v1.0</span>
        </div>
      </nav>

      <main className="pr-main-content">
        <Outlet />
      </main>
    </div>
  );
}

export default PipelineLayout;
